import { memo } from 'react'
import { Sparkles } from 'lucide-react'
import { skillPreferencesDeeplink } from '@renderer/chat/integrations/skills/skill-preference-tool'
import type { StagedAction } from '../../../hooks/use-staged-actions'

/**
 * A note under a draft saying what editing it taught Highlight.
 *
 * Here rather than in chat: chat's equivalent notice renders off an
 * `add_skill_preference` tool call, and this panel renders no tool calls.
 */

function readString(metadata: unknown, key: string): string | null {
  if (!metadata || typeof metadata !== 'object') return null
  const value = (metadata as Record<string, unknown>)[key]
  return typeof value === 'string' && value.trim().length > 0 ? value : null
}

export const LearnedPreferenceNotice = memo(function LearnedPreferenceNotice({
  action,
}: {
  action: StagedAction | undefined
}) {
  const rule = readString(action?.metadata, 'learnedPreference')
  const skillId = readString(action?.metadata, 'learnedPreferenceSkillId')

  if (!rule) return null

  return (
    <div className="text-foreground-secondary type-ui-xs flex items-start gap-1.5 py-1.5">
      <Sparkles className="mt-0.5 size-3 shrink-0" strokeWidth={2.25} />
      <span className="min-w-0">
        Learned from your edits: <span className="text-foreground">{rule}</span>
        {skillId ? (
          <>
            {' · '}
            <button
              type="button"
              className="text-foreground-secondary hover:text-foreground underline underline-offset-2"
              onClick={() => {
                try {
                  window.open(skillPreferencesDeeplink(skillId), '_blank')
                } catch (error) {
                  console.warn('[learned-preference] could not open settings', error)
                }
              }}
            >
              View Skill
            </button>
          </>
        ) : null}
      </span>
    </div>
  )
})
